var _line, _line2, _line3, _line4, _line5, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPulsePositive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 146,
    height: 28,
    viewBox: "0 0 146 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: 27.5,
    x2: 49.4573,
    y2: 27.5,
    stroke: "#97A6C8",
    strokeDasharray: "2 2"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 48.3333,
    y1: 0.5,
    x2: 96.6666,
    y2: 0.5,
    stroke: "#97A6C8"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 95.5426,
    y1: 27.5,
    x2: 145,
    y2: 27.5,
    stroke: "#97A6C8"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 48.9573,
    y1: 27,
    x2: 48.9573,
    y2: 1.47349e-8,
    stroke: "#97A6C8",
    strokeDasharray: "2 2"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 96.1666,
    y1: 28,
    x2: 96.1666,
    y2: 1,
    stroke: "#97A6C8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M95.1236 14.1768C95.2213 14.0791 95.2213 13.9209 95.1236 13.8232L93.5326 12.2322C93.435 12.1346 93.2767 12.1346 93.1791 12.2322C93.0814 12.3299 93.0814 12.4882 93.1791 12.5858L94.5933 14L93.1791 15.4142C93.0814 15.5118 93.0814 15.6701 93.1791 15.7678C93.2767 15.8654 93.435 15.8654 93.5326 15.7678L95.1236 14.1768ZM79.4706 14.25L94.9468 14.25L94.9468 13.75L79.4706 13.75L79.4706 14.25Z",
    fill: "#828FAB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7102 10.6621H70.425V17H69.4924V10.6621H67.2122V9.89062H72.7102V10.6621ZM76.4993 17H75.5911V10.9795L73.7698 11.6484V10.8281L76.3577 9.85645H76.4993V17Z",
    fill: "#00CBAF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M50.4043 14.1768C50.3067 14.0791 50.3067 13.9209 50.4043 13.8232L51.9953 12.2322C52.093 12.1346 52.2512 12.1346 52.3489 12.2322C52.4465 12.3299 52.4465 12.4882 52.3489 12.5858L50.9347 14L52.3489 15.4142C52.4465 15.5118 52.4465 15.6701 52.3489 15.7678C52.2512 15.8654 52.093 15.8654 51.9953 15.7678L50.4043 14.1768ZM66.0574 14.25L50.5811 14.25L50.5811 13.75L66.0574 13.75L66.0574 14.25Z",
    fill: "#828FAB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M145.177 14.1768C145.274 14.0791 145.274 13.9209 145.177 13.8232L143.586 12.2322C143.488 12.1346 143.33 12.1346 143.232 12.2322C143.135 12.3299 143.135 12.4882 143.232 12.5858L144.647 14L143.232 15.4142C143.135 15.5118 143.135 15.6701 143.232 15.7678C143.33 15.8654 143.488 15.8654 143.586 15.7678L145.177 14.1768ZM128.73 14.25L145 14.25L145 13.75L128.73 13.75L128.73 14.25Z",
    fill: "#828FAB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M121.626 10.6621H119.341V17H118.408V10.6621H116.128V9.89062H121.626V10.6621ZM127.104 17H122.446V16.3506L124.907 13.6162C125.272 13.2028 125.522 12.8675 125.659 12.6104C125.799 12.3499 125.869 12.0814 125.869 11.8047C125.869 11.4336 125.757 11.1292 125.532 10.8916C125.308 10.654 125.008 10.5352 124.634 10.5352C124.184 10.5352 123.835 10.6637 123.584 10.9209C123.336 11.1748 123.213 11.5296 123.213 11.9854H122.309C122.309 11.3311 122.519 10.8021 122.939 10.3984C123.363 9.99479 123.927 9.79297 124.634 9.79297C125.294 9.79297 125.817 9.96712 126.201 10.3154C126.585 10.6605 126.777 11.1211 126.777 11.6973C126.777 12.3971 126.331 13.2305 125.439 14.1973L123.535 16.2627H127.104V17Z",
    fill: "#00CBAF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M98.1825 14.1768C98.0849 14.0791 98.0849 13.9209 98.1825 13.8232L99.7735 12.2322C99.8712 12.1346 100.029 12.1346 100.127 12.2322C100.225 12.3299 100.225 12.4882 100.127 12.5858L98.7129 14L100.127 15.4142C100.225 15.5118 100.225 15.6701 100.127 15.7678C100.029 15.8654 99.8712 15.8654 99.7735 15.7678L98.1825 14.1768ZM114.629 14.25L98.3593 14.25L98.3593 13.75L114.629 13.75L114.629 14.25Z",
    fill: "#828FAB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPulsePositive);
export default __webpack_public_path__ + "static/media/pulse-positive.34943fd082764f16d080e8aa72843741.svg";
export { ForwardRef as ReactComponent };